import { render, staticRenderFns } from "./orderDriverCustomize.vue?vue&type=template&id=a16d8adc&scoped=true"
import script from "./orderDriverCustomize.vue?vue&type=script&lang=js"
export * from "./orderDriverCustomize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16d8adc",
  null
  
)

export default component.exports